export const uploadAdvertReport = (payload?: any) => ({
    type: "@saga/UPLOAD_ADVERT_REPORT",
    payload
});

